package dev.danko.roblox_craft_ai.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import dev.danko.roblox_craft_ai.state.AuthState
import kotlinx.browser.window

/** Pages open to everyone in the invite-only phase. */
private val PUBLIC_PATHS = listOf("/welcome", "/legal/", "/auth/verify")

private fun isPublic(path: String) = PUBLIC_PATHS.any { path == it.trimEnd('/') || path.startsWith(it) }

/**
 * In the invite-only phase visitors who are not signed in are sent to the promo page; everything else renders
 * as usual. Nothing is shown until the server config is known, so protected pages never flash or call the API.
 */
@Composable
fun AccessGate(content: @Composable () -> Unit) {
    val path = window.location.pathname
    val blocked = AuthState.inviteOnly && AuthState.user == null && !isPublic(path)
    if (!AuthState.ready && !isPublic(path)) return
    if (blocked) {
        LaunchedEffect(path) { window.location.replace("/welcome") }
        return
    }
    content()
}
